import { extendTheme } from '@chakra-ui/react';
import '@fontsource/raleway/400.css'
import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';


const colors = {
    primary: {
        100: '#f5f3ee',
        200: '#f2ebe4',
        300: '#ef8451',
        400: '#f08453',
        500: '#f08453',
        600: '#ef8451',
        700: '#0f393b',
    },
    background: '#f5f3ee',
    text: '#0f393b',
};

const theme = extendTheme({
    fonts: {
        heading: `'Inter', sans-serif`,
        body: `'Inter', sans-serif`,
    },
    colors,
});

export default theme;
